import axios, { API_ENDPOINTS } from 'src/utils/axios';
// check write_access & read_access & full_access
export const getRolePermissions = async (params)=>{
    try {
      const response = await axios({
        method: "get",
        url: API_ENDPOINTS.role.permissions,
        params
      });
      return response.data;
    } catch (error) {
      return false;
    }
  }
  
export const permissions =[
    {
      path:'/dashboard',
      permissionType :'full_access',
      permissionName:'dashboard'
    },
    {
        path:'/dashboard/user',
        permissionType :'full_access',
        permissionName:'user_management'
    },
    {
        path:'/dashboard/user/new',
        permissionType :'write_access',
        permissionName:'user_management'
    },
    {
        path:'/dashboard/user/:id/edit',
        permissionType :'write_access',
        permissionName:'user_management'
    },
    {
        path:'/dashboard/role',
        permissionType :'full_access',
        permissionName:'role_management'
    },
    {
        path:'/dashboard/role/new',
        permissionType :'write_access',
        permissionName:'role_management'
    },
    {
        path:'/dashboard/role/:id/edit',
        permissionType :'write_access',
        permissionName:'role_management'
    },
    {
        path:'/dashboard/applications',
        permissionType :'full_access',
        permissionName:'application_management'
    },
    {
        path:'/dashboard/applications/new',
        permissionType :'write_access',
        permissionName:'application_management'
    },
    {
        path:'/dashboard/applications/:id/edit',
        permissionType :'write_access',
        permissionName:'application_management'
    },
    {
        path:'/dashboard/applications/:id/delete',
        permissionType :'write_access',
        permissionName:'application_management'
    },
    {
        path:'/dashboard/talent',
        permissionType :'full_access',
        permissionName:'talent_management'
    },
    {
        path:'/dashboard/talent/new',
        permissionType :'write_access',
        permissionName:'talent_management'
    },
    {
        path:'/dashboard/leads',
        permissionType :'full_access',
        permissionName:'lead_management'
    },
    {
        path:'/dashboard/talent-types',
        permissionType :'full_access',
        permissionName:'talent_type_management'
    },
    {
        path:'/dashboard/talent-types/new',
    },
    {
        path:'/dashboard/contact-forms',
        permissionType :'full_access',
        permissionName:'contact_form_management'
    },
    {
        path:'/dashboard/contact-forms/:id',
        permissionType :'read_access',
        permissionName:'contact_form_management'
    },
];